import { PrismicRichText } from "@prismicio/react";
import React from 'react';
import { components } from "../../utils/rt-mods";

export const TextBlockWithBg = (props) => {

    const sc = props.slice.primary;

    let space = sc.spacing;

    if (space === "Both large") {
        space = "gutter";
    } else if (space === "Both small") {
        space = "gutter sm";
    } else if (space === "Top large") {
        space = "gutter bot";
    } else if (space === "Top small") {
        space = "gutter bot sm";
    } else if (space === "Bottom large") {
        space = "gutter top";
    } else {
        space = "gutter top sm";
    }

    let bg = sc.background === "gradient" ? "gradient-to-b from-grey-light to-white" : sc.background;

    let bgImg = {backgroundImage: `url(${sc.background_image.url})`}


    return (
        <section className={"textblock article bg-" + (bg) + " " + (sc.theme) + " " + (space)}>
            <div style={bgImg} className={"section-bg" + (sc.fade ? ' fade' : '')} />
            <div className="wrapper">
                <div className={bg === 'grey' ? ' text-white' : 'text-grey'}>
                    <div className="text-center w-3/4 m-auto">
                        <PrismicRichText field={sc.section_title.richText} />
                        <PrismicRichText field={sc.section_content.richText} components={components} />
                    </div>  
                    <div dangerouslySetInnerHTML={{ __html: sc.custom_html }} />
                </div>
                
            </div>
        </section>
    );
}

